import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import get from 'lodash.get'
import ErrorBoundary from '../../../molecules/ErrorBoundary'
import MetricRing from '../dataviz/MetricRing'
import { planning } from '../../../../api/integrations'

function Ring ({
  clientId,
  planType,
  metrics,
  chartOptions,
  seriesOptions
}) {
  const { data, isLoading } = planning.usePlanningQuery({ queryType: 'montecarlo', payload: { clientId, planType } })

  const chartData = useMemo(() => {
    if (isLoading || !Object.keys(data ?? {}).length) return []

    return metrics.map((metric) => {
      const value = get(data, metric.accessor)
      const pV = metric.target ? (value * 100.0) / metric.target : (value * 100.0)

      return {
        value: pV * 100,
        name: metric.name || ''
      }
    })
  }, [data, metrics, isLoading])

  return (
    <MetricRing
      chartData={chartData}
      chartOptions={chartOptions}
      seriesId={planType}
      {...seriesOptions}
    />
  )
}

Ring.propTypes = {
  clientId: PropTypes.number,
  planType: PropTypes.string,
  metrics: PropTypes.object,
  chartOptions: PropTypes.array,
  seriesOptions: PropTypes.object
}

function MontecarloView ({
  clientId,
  pageTitle,
  metrics,
  chartOptions,
  ...seriesOptions
}) {
  return (
    <ErrorBoundary name={pageTitle}>
      {Object.entries(metrics).map(([key, value]) => (
        <Ring
          key={key}
          clientId={clientId}
          planType={key}
          metrics={value}
          chartOptions={chartOptions}
          seriesOptions={seriesOptions}
        />
      ))}
    </ErrorBoundary>
  )
}

MontecarloView.propTypes = {
  clientId: PropTypes.number,
  pageTitle: PropTypes.string,
  metrics: PropTypes.object,
  chartOptions: PropTypes.object,
  seriesOptions: PropTypes.object
}

MontecarloView.defaultProps = {
  chartOptions: {
    height: 500,
    width: 500
  },
  metrics: {
    current: [{
      accessor: 'probabilityOfSuccess',
      target: 100,
      name: 'Current'
    }],
    proposed: [{
      accessor: 'probabilityOfSuccess',
      target: 100,
      name: 'Proposed'
    }]
  },
  height: 500,
  width: 500
}

export default MontecarloView
